import { render } from "./invoicepaid.vue?vue&type=template&id=fb6634fe"
import script from "./invoicepaid.vue?vue&type=script&lang=js"
export * from "./invoicepaid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__